import { observer } from 'mobx-react-lite'
import { Alert, Button } from 'shared/ui'
import { logout } from 'entities/Auth/lib/logout'
import { type PasswordChangeForcePageStore } from 'pages/auth/pages/passwordChangeForce/store/passwordChangeForcePageStore'
import styles from './styles.module.scss'

type IFormProps = {
  store: PasswordChangeForcePageStore
}

export const PasswordChangeForceForm = observer(({ store }: IFormProps) => {
  const { loading, success, error, sendResetPasswordLink } = store

  return (
    <div className={styles.wrap}>
      {error && (
        <Alert
          className={styles.alertError}
          item={{
            type: 'error',
            desc: error,
          }}
        />
      )}

      <div className={styles.buttonsRow}>
        {!success && (
          <Button
            className={styles.button}
            typeBtn='contained'
            type='button'
            onClick={sendResetPasswordLink}
            loading={loading}
            disabled={loading}
            text={'Reset password'}
            contained={'primary'}
          />
        )}

        <Button
          className={styles.button}
          onClick={logout}
          typeBtn={'outlined'}
          contained={'secondary'}
          text={'Logout'}
        />
      </div>
    </div>
  )
})

export default PasswordChangeForceForm
